export const ICON_SIZE = {
  xxs: 8,
  tiny: 12,
  extraSmall: 16,
  small: 20,
  medium: 24,
  large: 40,
  extraLarge: 48,
  xxl: 64,
  tutorial: 80,
}

export const ICON_VIEWBOX = {
  xxs: `0 0 ${ICON_SIZE.xxs} ${ICON_SIZE.xxs}`,
  tiny: `0 0 ${ICON_SIZE.tiny} ${ICON_SIZE.tiny}`,
  extraSmall: `0 0 ${ICON_SIZE.extraSmall} ${ICON_SIZE.extraSmall}`,
  small: `0 0 ${ICON_SIZE.small} ${ICON_SIZE.small}`,
  medium: `0 0 ${ICON_SIZE.medium} ${ICON_SIZE.medium}`,
  large: `0 0 ${ICON_SIZE.large} ${ICON_SIZE.large}`,
  extraLarge: `0 0 ${ICON_SIZE.extraLarge} ${ICON_SIZE.extraLarge}`,
} as const

export const DEFAULT_LINE_STROKE = 1.5

export const DEFAULT_FILL_OPACITY = 0.87
